const blogContext = require.context('./content/blogs', false, /\.js$/);

// Utility function to generate a slug from the title
const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/&/g, 'and') // Replace ampersands with "and"
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
    .replace(/^-|-$/g, ''); // Remove leading or trailing hyphens
};
export const loadBlogs = () => {
  return blogContext.keys().map((key) => {
    const blog = blogContext(key);
    const slug = generateSlug(blog.title); // Generate slug from the title
    return { slug, ...blog };
  });
};
